import { put, call, take, fork } from 'redux-saga/effects'
import { questionTagAddService } from '../../api/question'
import { questionTagAddSuccess } from '../../reducers/question/action'
import { QUESTION_TAG_ADD } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionTagAddFlow(payload) {
  try {
    const { entity } = payload
    const response = yield call(questionTagAddService, entity)

    yield put(questionTagAddSuccess(response.data))
    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionTagAddWatcher() {
  while (true) {
    const action = yield take(QUESTION_TAG_ADD)
    const { payload } = action

    yield fork(generalSaga, questionTagAddFlow, payload)
  }
}
